import katex from 'katex'

import 'katex/dist/katex.min.css'

import { EditorClasses } from '@/styles'

import type { AttributesMath } from './attributes'
import { html } from '@/helpers/html-template'
import { toVueComponent } from '@scalar-org/vue-render'
import { safeCompute } from '@/helpers/safe-compute'

export function guideMathHtml(props: AttributesMath) {
  const katexContent = safeCompute({
    method: () => katex.renderToString(props.equation || ''),
    fallback: 'Invalid Latex provided',
  })

  return html`
    <figure
      class="${EditorClasses.Math}">
      <div
        class="katex-display">${katexContent}</div>
      ${props.caption && html`<figcaption>${props.caption}</figcaption>`}
    </figure>
  `
}

/** Scalar Math wrapped in Vue for usage in the Tiptap extensions */
export const ScalarMathVue = toVueComponent<AttributesMath>(guideMathHtml, {
  equation: String,
  caption: String,
})
